import { useContext } from 'react';
import { OptionsContext } from 'contexts/OptionsContext';

export function useOptions() {
  const context = useContext(OptionsContext);

  return context;
}
